module.exports = __webpack_public_path__ + "media/assets/icons/friends-white-5ad4b9003c2695e333df82f392a19c0c.svg";